exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-title[data-v-563cadb8]{color:#909399;font-size:larger;margin:10px 0}\n", ""]);

// exports
